import Routes from "./router";

function App() {
  return <Routes />;
}

export default App;
